import React, { useEffect, useMemo, useState } from 'react'
import axios from 'axios';
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment';
import Papa from "papaparse";
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from '../../../hooks/usePermissionGuard';
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import { lockAllProgrammeGrades, lockGradeProgrammeToggle } from "../../../services/GradeSettingService";
import { LinkedNetsuiteProductCourseList, LinkedNetsuiteProductCourseListFilters, UnlinkedIntakeToProgramme } from '../../../services/ProgramService';
import { RenderCampus, RenderLearningMethod, RenderProgrammeType } from '../../../utils/CommonGroupingItem';
import { TABLE_DATE_FORMAT, TABLE_ROWS_PER_PAGE } from '../../../utils/Constants';
import { handleTableScroll } from '../../../utils/commonFunction';
import PermissionsGate from '../../../utils/permissionGate';
import Str from "../../common/Str";
import Tablefilter from '../../common/Tablefilter';
import { TrimText } from '../../common/TrimText';
import LPTable from './LPTable';

function LinkedProgrammes(props) {
    const { detail, QAview, isVersionEnabled } = props;
    const {id} = useParams()
    const [gradeLockLoading, setGradeLockLoading] = useState({});
    const [search, setSearch] = useState("");
    const [intake, setIntake] = useState({ arr: [], checkObj: {} });
    const [campus, setCampus] = useState({ arr: [], checkObj: {} });
    const [delivery, setDelivery] = useState({ arr: [], checkObj: {} });
    const [courseType, setCourseType] = useState({ arr: [], checkObj: {} });
    const [loading, setLoading] = useState();
    const [listData,setListData] = useState([])
    const [linkedQualifications, setLinkedQualifications] = useState([])
    const [dropdown, setDropdown] = useState({intake : [],campus: [],deliveryMethod :[],courseType : [],versionFilters : [],Programm_Modules_Filters : []})
    const [toggle,setToggle] = useState(false)
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [sortkey, setSortKey] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [totalRows, setTotalRows] = useState(0)
    const [gradesLocked, setGradesLocked] = useState({ arr: [], checkObj:{}})
    const [version,setVersion] = useState({arr : [], checkObj : {}})
    const [programmeModule,setProrammeModule] = useState({arr : [], checkObj : {}})
    const [showAll,setShowAll] = useState([])
    const [updateData, setUpdateData] = useState(false)
    
    
    useEffect(() => {
        handleTableScroll()
    }, [loading])
    const handleLockGrade = (rowId, currentStatus) => {
        setGradeLockLoading(prev => ({ ...prev, [rowId]: true }));
        lockGradeProgrammeToggle(rowId ,currentStatus == 1 ? 0 : 1,id)
        .then((res) => {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: res.data.message,
            });
            setUpdateData(prev => !prev);
            setGradeLockLoading(prev => ({ ...prev, [rowId]: false }));
        })
        .catch((err) => {
            console.error("error :", err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: err?.response?.data?.message ?? err?.response?.data?.error,
            });
            setGradeLockLoading(prev => ({ ...prev, [rowId]: false }));
        });
    }
    
    const handleLockAllGrades = () => {
        setGradeLockLoading(prev => ({ ...prev, lockAll: true }));
        if(linkedQualifications?.length > 0){
            lockAllProgrammeGrades(linkedQualifications ,1, id)
            .then((res) => {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: res.data.message,
                });
                setGradeLockLoading(prev => ({ ...prev, lockAll: false }));
                setUpdateData(prev => !prev);
            })
            .catch((err) => {
                console.error("error :", err);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: err?.response?.data?.message ?? err?.response?.data?.error,
                });
                setGradeLockLoading(prev => ({ ...prev, lockAll: false }));
            });
        }
    }
    const handleUnlockAllGrades = () => {
        setGradeLockLoading(prev => ({ ...prev, unlockAll: true }));
        if(linkedQualifications?.length > 0){
            lockAllProgrammeGrades(linkedQualifications ,0,id)
            .then((res) => {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: res.data.message,
                });
                setGradeLockLoading(prev => ({ ...prev, unlockAll: false }));
                setUpdateData(prev => !prev);
            })
            .catch((err) => {
                console.error("error :", err);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: err?.response?.data?.message ?? err?.response?.data?.error,
                });
                setGradeLockLoading(prev => ({ ...prev, unlockAll: false }));
            });
        }
    }
    
    const handlePageChange = (pageNo) => {
        setPage(pageNo);
    };
    
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
    };
    
    const handleSort = (column, sortDirection) => {
        setSortKey(column.sortField);
        setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
    };

    useEffect(() => {
        const getFilters = async () => {
            try {
                const response = await LinkedNetsuiteProductCourseListFilters(id,detail?.netsuite_product,1)
                if (response.status === 200) {
                    const programm_modules = [...(response.data?.Programm_Modules_Filters || [])]
                        .sort((a, b) =>
                            a.label?.toLowerCase().localeCompare(b.label?.toLowerCase())
                        );

                    setDropdown(prev => ({
                        ...prev,
                        intake: response.data?.yearsAndIntaksFilters,
                        campus: response.data?.campusFilter,
                        deliveryMethod: response.data?.intakeTypeFilters,
                        versionFilters : response.data?.versionFilters,
                        courseType: response.data?.subjectTypeFilter,
                        Programm_Modules_Filters: programm_modules
                    }));
                }
            } catch (err) {
                console.error("Error fetching filters:", err);
            }
        };

        if (detail && Object.keys(detail).length > 0) {
            getFilters();
        };
    }, [detail, toggle, intake, delivery, courseType, search, sortOrder, sortkey, campus, page, perPage]);    
    
    useEffect(() => {
        const source = axios.CancelToken.source();
        
        const getListData = async () => {
            setLoading(true);
            try {
                const data = {
                    programme_id: id,
                    netsuite_product_id: detail?.netsuite_product,
                    isAssigned: 1,
                    page,
                    limit: perPage,
                    key: sortkey,
                    sort: sortOrder,
                    search,
                    viaCampus: campus.arr.length ? campus.arr : [],
                    intake: intake.arr.length ? intake.arr : [],
                    viaLearnType: delivery.arr.length ? delivery.arr : [],
                    viaCourseType: courseType.arr.length ? courseType.arr : [],
                    viaGradesLocked: gradesLocked.arr.length ? gradesLocked.arr : [],
                    viaVersion: version.arr.length ? version.arr : [],
                    viaModule: programmeModule.arr.length ? programmeModule.arr : [],
                };
                const response = await LinkedNetsuiteProductCourseList(data, source.token);
                if (response?.status === 200) {
                    setListData(response.data.data.data);
                    setLinkedQualifications(response?.data?.allQualificationIds);
                    setTotalRows(response.data.data.total);
                    setLoading(false);
                }
            } catch (error) {
                if (!axios.isCancel(error)) console.error(error);
                setLoading(false);
            }
        };

        if (detail && Object.keys(detail).length > 0) getListData();

        return () => source.cancel("Component unmounted");
    }, [detail, toggle, intake, delivery, courseType, gradesLocked, search, sortOrder, sortkey, campus, page, perPage, updateData, version, programmeModule]);    

    usePermissionGuardRedirect(['matpview']);

    const resetFilter = () => {
        setSearch("");
        setIntake({ arr: [], checkObj: {} });
        setCampus({ arr: [], checkObj: {} });
        setDelivery({ arr: [], checkObj: {} });
        setCourseType({ arr: [], checkObj: {} });
        setGradesLocked({ arr: [], checkObj: {} });
        setProrammeModule({ arr: [], checkObj: {} });
        setVersion({ arr: [], checkObj: {} });
    };
    
    const handlerefresh = () => {
        setToggle(!toggle)
    }

    const exportData = (fileType, fileName) => {
        let header = [
            "Name",
            "Intake",
            "Campus",
            "Delivery Method",
            "Start Date",
            "End Date",
            "Programme Type",
            "Students",
            "Grade Lock Status",
            "Version"
        ];

        // Columns to remove in QA view
        const qaRemoveColumns = ["Grade Lock Status", "Campus", "Start Date", "End Date", "Programme Type","Students"];
        
        //removing version column if not enabled versioning
        if(!QAview && !isVersionEnabled){
            header = header.filter(col => col !== "Version");
        }

        // Remove QA columns if QAview is true
        if (QAview) {
            header = header.filter(col => !qaRemoveColumns.includes(col));
        }

        Swal.fire({
            title: "File downloading...",
            onOpen: () => Swal.showLoading(),
        });

        const cData = {
            module_id: id,
            netsuite_product_id: detail?.netsuite_product,
            isAssigned: 1,
            page,
            limit: perPage,
            key: sortkey,
            sort: sortOrder,
            search,
            viaCampus: campus.arr.length ? campus.arr : [],
            intake: intake.arr.length ? intake.arr : [],
            viaLearnType: delivery.arr.length ? delivery.arr : [],
            viaCourseType: courseType.arr.length ? courseType.arr : [],
            viaGradesLocked: gradesLocked.arr.length ? gradesLocked.arr : [],
            viaVersion: version.arr.length ? version.arr : [],
            viaModule: programmeModule.arr.length ? programmeModule.arr : [],
            programme_id: id,
            exportStatus: "true"
        };

        LinkedNetsuiteProductCourseList(cData)
            .then(res => {
                const data = res.data?.data || [];
                const formattedData = data.map(row => ({
                    "Name": row.name || "-",
                    "Intake": row.intakes || "-",
                    "Campus": row.campus ? RenderCampus(row.campus).text : "-",
                    "Delivery Method": row.type ? RenderLearningMethod(row.type).text : "-",
                    "Start Date": row.start ? moment.unix(row.start).format(TABLE_DATE_FORMAT) : "-",
                    "End Date": row.end ? moment.unix(row.end).format(TABLE_DATE_FORMAT) : "-",
                    "Programme Type": row.subject_type || "-",
                    "Students": row.total_student ?? "-",
                    "Grade Lock Status": row?.isGradeLocked !== undefined
                        ? row.isGradeLocked == 1 ? "Yes" : "No"
                        : "-",
                    "Version": row?.version_name ?? "-"
                }));

                // Remove QA columns from data
                const compatibleData = QAview
                    ? formattedData.map(row => {
                        const newRow = { ...row };
                        qaRemoveColumns.forEach(col => delete newRow[col]);
                        return newRow;
                    })
                    : formattedData;

                    //removing version column if not enabled versioning
                    if(!QAview && !isVersionEnabled){
                        formattedData.forEach(row => delete row["Version"]);
                    }

                if (fileType === "csv") {
                    const csvString = Papa.unparse({ fields: header, data: compatibleData });
                    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });
                    const blobURL = URL.createObjectURL(blob);
                    const anchor = document.createElement("a");
                    anchor.download = `${fileName}.csv`;
                    anchor.href = blobURL;
                    anchor.click();
                    setTimeout(() => URL.revokeObjectURL(blobURL), 1000);
                    Swal.close();
                }
                else if (fileType === "xlsx") {
                    const ws = XLSX.utils.json_to_sheet(compatibleData, { header });
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Data");
                    XLSX.writeFile(wb, `${fileName}.xlsx`);
                    Swal.close();
                    return false;
                }
                else if (fileType === "pdf") {
                    const bodyData = compatibleData.map(row => header.map(col => row[col]));
                    const doc = new JsPDF();
                    doc.autoTable({
                        head: [header],
                        body: bodyData,
                        styles: {
                            minCellHeight: 10,
                            minCellWidth: 5,
                            halign: "left",
                            fontSize: 8,
                        },
                    });
                    doc.save(`${fileName}.pdf`);
                    Swal.close();
                    return false;
                }
            })
            .catch(error => {
                console.error("Export error:", error);
                Swal.fire("Error", "Failed to export data.", "error");
            });
    };
    
    const handleSearchFilter = (e) => {
        const value = e.target.value;
        setSearch(value);
    };
    
    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "name",
            sortField: "name",
            sortable: true,
            wrap: true,
            cell: row => (
                <PermissionsGate
                scopes={["matpedit"]}
                RenderError={() => <span className="feature-name"> <span className="textLimit100">{row?.name ?? "-"}</span></span>}
                >
                <Link
                to={`/courseAdministration/Programmes/programme/open/${row.id}/details`}
                title={row?.name ?? "-"}
                className="as-text-blue curser feature-name"
                >
                <span className="textLimit100">{row?.name ?? "-"}</span>
                </Link>
                </PermissionsGate>
            ),
        },
        {
            name: "Intake",
            selector: "intakes",
            sortField: "intakes",
            sortable: true,
            cell: row => (
                <div className="ticket-id">
                <span title={row?.intakes ?? "-"} className="overflow-ellipsis2">
                {row?.intakes ?? "-"}
                </span>
                </div>
            ),
        },
        ...((!QAview || !isVersionEnabled) ? [] : [{
            name : "Version",
            selector: "version",
            sortable: false,
            cell: row => {
                return (
                    <div className="versionText">
                        {row?.version_id && row?.version_name ? (
                            <p className="d-flex align-items-center">
                                {row?.override_pmc_version && row?.pmc_version_id != row?.version_id ? (
                                    <i className="fas fa-exclamation-circle bg-orange-icon orangeText"></i>
                                ) : (
                                    <i className="fas fa-check-circle greenText"></i>
                                )}
                                <Link
                                    to={`/program-management-center/programmes/versions/details?versionId=${row?.override_pmc_version && row?.pmc_version_id != row?.version_id ? row?.pmc_version_id : row?.version_id}&programmeId=${id}`}
                                    title={row?.version_name ?? "-"}
                                    className="as-text-blue curser d-flex align-item-center"
                                >
                                    <span className="textLimit100 no-break-text ml-1">{row?.version_name ?? "-"}</span>
                                </Link>
                            </p>
                        ) : (
                            "-"
                        )}
                    </div>
                );
            }

        }]),
        ...(QAview ? [] : [{
            name: "Campus",
            selector: "campus",
            sortField: "campus",
            cell: row => (
                <div className="ticket-id">
                <span title={row?.campus ?? "-"} className="overflow-ellipsis2">
                {row?.campus ? RenderCampus(row.campus).html : ""}
                </span>
                </div>
            ),
        }]),
        {
            name: "Delivery Method",
            selector: "type",
            sortField: "type",
            sortable: true,
            cell: row => (
                <p className="">
                {row && row.type ? RenderLearningMethod(row.type).html : "-"}
                </p>
            ),
        },
        ...(QAview ? [] : [{
            name: "Start Date",
            selector: "start",
            sortField: "start",
            sortable: true,
            cell: row => (
                <div className="ticket-id">
                    <span
                        title={row?.start ? moment.unix(row.start).format(TABLE_DATE_FORMAT) : "-"}
                        className="overflow-ellipsis2"
                    >
                        {row?.start ? moment.unix(row.start).format(TABLE_DATE_FORMAT) : "-"}
                    </span>
                </div>
            ),
        },
        {
            name: "End Date",
            selector: "end",
            sortField: "end",
            sortable: true,
            cell: row => (
                <div className="ticket-id">
                <span title={row?.end ? moment.unix(row.end).format(TABLE_DATE_FORMAT) : "-"} className="overflow-ellipsis2">
                {row?.end ? moment.unix(row.end).format(TABLE_DATE_FORMAT) : "-"}
                </span>
                </div>
            ),
        },
        {
            name: "Programme Type",
            selector: "subject_type",
            sortField: "subject_type",
            cell: row => (row.subject_type ? RenderProgrammeType(row.subject_type).html : "-"),
        },
        {
            name: "Students",
            selector: "total_student",
            sortField: "total_student",
            sortable: true,
            cell: row => (
                <div className="ticket-id">
                <span title={row?.total_student != null ? row.total_student : "-"} className="overflow-ellipsis2">
                {row?.total_student != null ? row.total_student : "-"}
                </span>
                </div>
            ),
        },
        {
            name: "Grades Locked",
            selector: "isGradeLocked",
            sortable: false,
            cell: row => (
                <div className="ticket-id">
                <span title={row?.isGradeLocked == 1 ? "Locked" : "Unlocked"} className="overflow-ellipsis2">
                {row.isGradeLocked == 1 ? (
                    <>
                    {gradeLockLoading[row.id] ? <i className="fas fa-cog fa-spin"></i> : <i className='fal fa-circle-check greenText'></i>}
                    </>
                ) : (
                    <>
                    {gradeLockLoading[row.id] ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-circle-x redText"></i>}
                    </>
                )}
                </span>
                </div>
            ),
        }]),
        ...((!QAview && isVersionEnabled) ? [{
            name: "Version",
            selector: "version",
            sortable: false,
            cell: row => {
                return (
                    <div className="versionText">
                        {row?.version_id && row?.version_name ? (
                            <p className="d-flex align-items-center">
                                {row?.override_pmc_version && row?.pmc_version_id != row?.version_id ? (
                                    <i className="fas fa-exclamation-circle bg-orange-icon orangeText"></i>
                                ) : (
                                    <i className="fas fa-check-circle greenText"></i>
                                )}
                                <Link
                                    to={`/program-management-center/programmes/versions/details?versionId=${row?.override_pmc_version && row?.pmc_version_id != row?.version_id ? row?.pmc_version_id : row?.version_id}&programmeId=${id}`}
                                    title={row?.version_name ?? "-"}
                                    className="as-text-blue curser d-flex align-item-center"
                                >
                                    <span className="textLimit100 no-break-text ml-1">{row?.version_name ?? "-"}</span>
                                </Link>
                            </p>
                        ) : (
                            "-"
                        )}
                    </div>
                );
            }

        }] : []),
        ...(QAview ? [{
            name: "Programme Modules",
            selector: "start",
            sortField: "start",
            cell: row => {
                return renderRow(row, showAll, setShowAll)
            }
        }] : []),
        {
            name: "Actions",
            selector: "",
            cell: row => (
                <div className="assessment-08">
                <div className="as-buttons">
                <PermissionsGate
                scopes={["matpedit"]}
                RenderError={() => (
                    <button
                    className="btn btn-primary rounded-circle"
                    title="Open"
                    disabled
                    >
                    <i className="fal fa-folder-open"></i>
                    </button>
                )}
                >
                <Link
                to={`/courseAdministration/Programmes/programme/open/${row.id}/details`}
                className="btn btn-primary rounded-circle"
                title="Open"
                >
                <i className="fal fa-folder-open"></i>
                </Link>
                </PermissionsGate>
                <PermissionsGate
                scopes={["capgsedit"]}
                errorProps={{ disabled: true }}
                >
                <button
                className="btn btn-primary rounded-circle"
                onClick={() => handleLockGrade(row?.id, row?.isGradeLocked)}
                title={row.isGradeLocked == 1 ? "Unlock Grades" : "Lock Grades"}
                disabled={gradeLockLoading[row.id] || gradeLockLoading.lockAll || gradeLockLoading.unlockAll}
                >
                <>
                {row.isGradeLocked == 1 ? (
                    <>
                    {gradeLockLoading[row.id] ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-unlock"></i>}
                    </>
                ) : (
                    <>
                    {gradeLockLoading[row.id] ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-lock"></i>}
                    </>
                )}
                </>
                </button>
                </PermissionsGate>
                <PermissionsGate
                scopes={["matpadd"]}
                RenderError={() => (
                    <button
                    className="btn btn-primary rounded-circle"
                    title="Open"
                    disabled
                    >
                    <i className="fal fa-folder-open"></i>
                    </button>
                )}
                >
                <button
                onClick={() => unlink(row.id)}
                disabled={gradeLockLoading[row.id] || gradeLockLoading.lockAll || gradeLockLoading.unlockAll}
                className="btn btn-danger rounded-circle"
                title="Unlink"
                >
                <i className="fal fa-unlink"></i>
                </button>
                </PermissionsGate>
                </div>
                </div>
            ),
        },
    ]);
    
    const unlink = (programme_id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, unlink it!",
        }).then((result) => {
            if(result.isConfirmed) {
                Swal.fire({
                    title: "Please Wait !",
                    allowOutsideClick: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                const data = {
                    programme_id:programme_id,
                    netsuite_id:detail?.netsuite_product,
                    PMC_programme_id : id
                }
                UnlinkedIntakeToProgramme(data)
                .then(res => 
                    {
                        Swal.fire({
                            icon: "success",
                            title: "Programme Unlinked Successfully",
                        });
                        setToggle(!toggle);
                    }
                )
                .catch(err => console.log(err));
            }
        })
    };
    return (
        <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
        <div
        className="custom-table-div filter-search-icon card card-table-custom"
        >
        <div className="search-filter-div">
        <div className="search-filter-div-left">
        <div className="system-administration-table table-responsive">
        <div className="table-responsive-div">
        <div
        id="assessment-table-main_wrapper"
        className="dataTables_wrapper no-footer"
        >
        <div
        id="assessment-table-main_filter"
        className="dataTables_filter"
        >
        <label>
        <input
        type="search"
        className=""
        placeholder="Search"
        aria-controls="assessment-table-main"
        onChange={handleSearchFilter}
        value={search}
        />
        </label>
        <div className="filter-eff filter-data-btn">
        <button className="filter-buttons">
        <i className="fal fa-filter"></i>
        </button>
        </div>
        </div>
        </div>
        </div>
        <div className="filter-button-group">
        <div className="filter-scroll">
        <div className={`filter-scroll-inner  filter-custom-new`}>
        <Tablefilter
        filterName="Intake"
        optionArr={dropdown.intake || []}
        state={intake}
        setState={setIntake}
        isOptionReversed={true}
        />
        {QAview ? 
        <>
        <Tablefilter
        filterName="Version"
        optionArr={dropdown.versionFilters || []}
        state={version}
        setState={setVersion}
        />
        <Tablefilter
        filterName="Programme Modules"
        optionArr={dropdown.Programm_Modules_Filters || []}
        state={programmeModule}
        setState={setProrammeModule}
        stopOptionSorting
        />
        </> : 
        <>
        <Tablefilter
        filterName="Campus"
        optionArr={dropdown.campus || []}
        state={campus}
        setState={setCampus}
        />
        <Tablefilter
        filterName="Delivery Method"
        optionArr={dropdown.deliveryMethod || []}
        state={delivery}
        setState={setDelivery}
        renderLabelFunction={RenderLearningMethod}
        />
        <Tablefilter
        filterName="Programme Type"
        optionArr={dropdown.courseType || []}
        state={courseType}
        setState={setCourseType}
        />
        </>
        }
        <Tablefilter
        filterName="Grades Locked"
        optionArr={[
            {
                value: 1,
                label: "Yes"
            },
            {
                value: 0,
                label: "No"
            }]
        }
        state={gradesLocked}
        setState={setGradesLocked}        
        />
        {!QAview && isVersionEnabled && <Tablefilter
        filterName="Version"
        optionArr={dropdown.versionFilters || []}
        state={version}
        setState={setVersion}
        />}
        </div>
        </div>
        <div className="reset-btn-group">
        <div className="button-reset dropdown-comman">
        <button
        className="btn btn-primary"
        onClick={() => resetFilter()}
        title="Reset"
        >
        <i className="fal fa-redo"></i>Reset
        </button>
        </div>
        <div className="files-export-group">
        <button
        type="button"
        className="btn btn-files"
        onClick={() => {
            exportData("xlsx", "PMC");
        }}
        title="Export spreadsheet"
        >
        <i className="fal fa-file-excel icon"></i>
        </button>
        
        <button
        type="button"
        className="btn btn-files"
        onClick={() => {
            exportData("csv", "PMC");
        }}
        title="Export CSV"
        >
        <i className="fal fa-file-csv icon"></i>
        </button>
        
        <button
        type="button"
        className="btn btn-files"
        onClick={() => {
            exportData("pdf", "PMC");
        }}
        title="Export PDF"
        >
        <i className="fal fa-file-pdf icon"></i>
        </button>
        </div>
        </div>
        </div>
        </div>
        </div>
        <div className="search-filter-div-right">
        <div className=" filter-search-bar-blk">
        <button className="btn btn-primary mr-2" title="Link Programme" data-toggle="modal" data-target="#assignQuestion">
        <i className="fal fa-link"></i>Link Programme
        </button>
        {linkedQualifications?.length > 0 && (   
            <>
            <PermissionsGate
            scopes={["capgsedit"]}
            errorProps={{ disabled: true }}
            >
            <button
            className="btn btn-primary mr-2"
            onClick={() => handleLockAllGrades()}
            title={"Lock All Grades"}
            disabled={gradeLockLoading.lockAll || gradeLockLoading.unlockAll || Object.keys(gradeLockLoading).some(key => key !== 'lockAll' && key !== 'unlockAll' && gradeLockLoading[key])}
            >
            <>
            {gradeLockLoading.lockAll ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-lock"></i>} Lock All Grades
            </>
            </button>
            </PermissionsGate>
            <PermissionsGate
            scopes={["capgsedit"]}
            errorProps={{ disabled: true }}
            >
            <button
            className="btn btn-primary"
            onClick={() => handleUnlockAllGrades()}
            title={"Lock All Grades"}
            disabled={gradeLockLoading.lockAll || gradeLockLoading.unlockAll || Object.keys(gradeLockLoading).some(key => key !== 'lockAll' && key !== 'unlockAll' && gradeLockLoading[key])}
            >
            <>
            {gradeLockLoading.unlockAll ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-unlock"></i>} Unlock All Grades
            </>
            </button>
            </PermissionsGate>
            </>
        )}
        </div>
        </div>
        </div>
        <DataTable
        data={listData}
        columns={columns}
        pagination={true}
        onSort={handleSort}
        onChangeRowsPerPage={handlePerRowsChange}
        paginationTotalRows={totalRows}
        onChangePage={handlePageChange}
        paginationServer={true}
        progressComponent={<SkeletonTicketList />}
        progressPending={loading}
        noDataComponent={Str.noRecord}
        defaultSortAsc={true}
        defaultSortField={"name"}
        paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />
        </div>
        <div className="topic-add-modal modal fade" id="assignQuestion" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered available-assessment-modal" role="document">
        
        <div className="modal-content">
        <div className="modal-header modal-header-custom"><h5 className="modal-title"><i className="fal fa-link"></i> Link Programmes</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button></div>
        
        <LPTable handlerefresh={handlerefresh} toggle={toggle} setToggle={setToggle} detail={detail}/>
        </div>
        </div>
        </div>
        </div>
        
    )
}

export default LinkedProgrammes

const getColorAndIcon = (Matchstatus) => {
    let iconClass = "";
    let iconColor = "";
    if (Matchstatus == "1") {
        iconClass = "fas fa-check-square";
        iconColor = "greenText";
    } else if (Matchstatus == "2") {
        iconClass = "fal fa-times-square";
        iconColor = "redText";
    } else if (Matchstatus == "3") {
        iconClass = "fas fa-minus-square bg-orange-icon";
        iconColor = "orangeText";
    }

    return {iconClass ,iconColor}
}

const renderRow = (rowData, showAll, setShowAll) => {

    let vData = (rowData?.versionData?.moduleList || []).flatMap(module =>
        (module?.linked_course || []).map(course => ({
            ...module,
            linkedCourseInfo: course
        }))
    );
    const hasMoreThan3 = vData.length > 3;
    let data = showAll.includes(rowData?.id) ? vData : vData.slice(0, 3);

    if (data.length === 0) {
        return "-";
    }
    return (
        <>
            {data?.map((row, id) => {
                const { iconClass, iconColor } = getColorAndIcon(row?.linkedCourseInfo?.Matchstatus)
                return (
                    <>
                        <div className="row-wrapper" key={id}>
                            <div className={`icon-col`}>
                                <i className={`${iconClass} ${iconColor}`}></i>
                            </div>
                            <div className="module-col">
                                {row?.Portal ? <Link
                                    title={row?.Portal}
                                    to={`/program-management-center/modules/module/open/${row?.Id}`}
                                    className="as-text-blue font-600"
                                >
                                    {TrimText(row?.Portal, 20)}
                                </Link> : "-"}
                                <span className="netsuite_id" title={row?.linkedCourseInfo?.netsuiteProductId}>{row?.linkedCourseInfo?.netsuiteProductId}</span>
                            </div>
                            <div className="course-col">
                                {(row?.linkedCourseInfo?.course_name) ? <Link
                                    title={row?.linkedCourseInfo?.course_name}
                                    to={`/courseAdministration/coursesdetails/${row?.linkedCourseInfo?.id}/detailCourses/show`}
                                    className="as-text-blue font-600"
                                >
                                    {TrimText(row?.linkedCourseInfo?.course_name, 20)}
                                </Link> : "-"}
                                <span className="netsuite_id" title={row?.linkedCourseInfo?.netsuiteProductId}>{row?.linkedCourseInfo?.netsuiteProductId}</span>
                            </div>
                            <div className="intake-col" title={row?.linkedCourseInfo?.intake_label}>{row?.linkedCourseInfo?.intake_label || "-"}</div>
                            <div className="type-col">
                                {row?.linkedCourseInfo?.type ? RenderLearningMethod(row?.linkedCourseInfo?.type).html : "-"}
                            </div>
                            <div className="campus-col">
                                {row?.linkedCourseInfo?.campus ? RenderCampus(row?.linkedCourseInfo?.campus).html : "-"}
                            </div>
                        </div>

                    </>
                );
            })}
            {hasMoreThan3 && (
                <div className="mt-0 pragramme-name-wrapper">
                    <button
                        className="btn btn-link p-0 text-primary"
                        style={{ textDecoration: 'none' }}
                    >
                        {showAll.includes(rowData?.id) ? (
                            <>
                                <span
                                    title='See Less'
                                    className="see-more-btn cursor-pointer as-text-blue"
                                    onClick={() => {
                                        let arr = [...showAll]
                                        arr.splice(arr.findIndex(d => d == rowData?.id), 1)
                                        setShowAll(arr)
                                    }}
                                >
                                    See Less...
                                </span>
                            </>
                        ) : (
                            <span
                                title='See More'
                                className="see-more-btn cursor-pointer as-text-blue"
                                onClick={() => setShowAll([...showAll, rowData?.id])}
                            >
                                See More...
                            </span>
                        )}
                    </button>
                </div>
            )}
        </>
    )

};
